var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup402(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_402",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#486a41}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#f4f7f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_007-sticky-note",
    transform: "rotate(-8 291.871 -252.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    d: "M54.322 7.253h-14.2a9.315 9.315 0 0 0-18.167 0H7.76A7.757 7.757 0 0 0 0 14.99v46.374A7.757 7.757 0 0 0 7.76 69.1h39.917a2.024 2.024 0 0 0 1.429-.59l12.381-12.33a2.024 2.024 0 0 0 .6-1.434V14.99a7.758 7.758 0 0 0-7.76-7.737zm-23.281-3.2a5.229 5.229 0 1 1-5.258 5.228 5.249 5.249 0 0 1 5.258-5.228zM4.049 61.364V14.99A3.7 3.7 0 0 1 7.76 11.3h14.2a9.315 9.315 0 0 0 18.167 0h14.2a3.7 3.7 0 0 1 3.711 3.688v37.733H47.677a2.024 2.024 0 0 0-2.024 2.024v10.307H7.76a3.7 3.7 0 0 1-3.711-3.688zm51.108-4.594L49.7 62.2v-5.43z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    d: "M2.024 4.049h36.181a2.024 2.024 0 1 0 0-4.049H2.024a2.024 2.024 0 1 0 0 4.049z",
    className: "cls-2",
    transform: "translate(10.926 22.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    d: "M2.024 4.049h32.132a2.024 2.024 0 0 0 0-4.049H2.024a2.024 2.024 0 0 0 0 4.049z",
    className: "cls-2",
    transform: "translate(10.926 30.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    d: "M1.269 4.049h22.684c.7 0 1.269-.906 1.269-2.024S24.654 0 23.953 0H1.269C.568 0 0 .906 0 2.024s.568 2.025 1.269 2.025z",
    className: "cls-2",
    transform: "rotate(-30 106.561 6.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    d: "M1.269 4.049h22.684c.7 0 1.269-.906 1.269-2.024S24.654 0 23.953 0H1.269C.568 0 0 .906 0 2.024s.568 2.025 1.269 2.025z",
    className: "cls-2",
    transform: "rotate(30 -71.09 44.95)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup402);
export default __webpack_public_path__ + "static/media/Group 402.b0a8855af2a65ce558fb31c50907d9df.svg";
export { ForwardRef as ReactComponent };